export interface ITourService {
    startTour(): void;
    isTourLoading(): boolean;
}
export interface ITourAndStatus {
}

export enum TourEvents {
    start = 'tour:start'
}